import moment, { Moment } from 'moment/moment'

export interface PremiumTrialPayload {
    id: number
    user_id: number
    email: string
    product_id: string
    start_date: string | null
    end_date: string | null
    has_personalized_program: boolean
}

export class PremiumTrial {
    id: number
    userId: number
    email: string
    productId: string
    startDate: Moment | null
    endDate: Moment | null
    hasPersonalizedProgram: boolean

    constructor(data: PremiumTrialPayload) {
        this.id = data.id
        this.userId = data.user_id
        this.email = data.email
        this.productId = data.product_id
        this.startDate = data.start_date ? moment(data.start_date) : null
        this.endDate = data.end_date ? moment(data.end_date) : null
        this.hasPersonalizedProgram = data.has_personalized_program
    }
}
